import { render } from "./ctrl-bet-box-multi.vue?vue&type=template&id=0a542cb6&scoped=true&ts=true"
import script from "./ctrl-bet-box-multi.vue?vue&type=script&lang=ts"
export * from "./ctrl-bet-box-multi.vue?vue&type=script&lang=ts"

import "./ctrl-bet-box-multi.vue?vue&type=style&index=0&id=0a542cb6&lang=scss&scoped=true"

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a542cb6"]])

export default __exports__